import * as React from "react";
const SvgFiRrHatCowboySide = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-cowboy-side_svg__a)">
      <path
        fill="#062147"
        d="m22.746 3.344-.245-.245C19.778.37 15.39.29 12.716 2.92a7 7 0 0 0-.444.485L9.565 1.711a4.67 4.67 0 0 0-6.089 1.012L1.024 5.737a4.68 4.68 0 0 0-.14 5.728l1.452 1.972C.35 16.13.621 20.023 3.113 22.522l.246.247a4.17 4.17 0 0 0 2.97 1.232 4.16 4.16 0 0 0 2.966-1.232l13.45-13.48a4.215 4.215 0 0 0 0-5.944zM2.576 6.998l2.451-3.014a2.67 2.67 0 0 1 3.478-.579l6.57 4.11-2.88 2.886c-2.564-.553-5.607-.756-8.445 1.58l-1.253-1.703a2.68 2.68 0 0 1 .08-3.28zM7.88 21.356a2.18 2.18 0 0 1-1.552.645 2.18 2.18 0 0 1-1.552-.644l-.246-.247c-1.953-1.958-2.028-5.093-.167-6.989 1.563-1.594 3.19-2.094 4.83-2.094 1.401 0 2.812.365 4.2.724.844.218 1.698.44 2.524.55zm10.45-10.484c-.75.751-1.984.56-3.869.087l2.35-2.356 2.335 1.461zm3-2.996-.734.736-6.603-4.13c.042-.045.08-.092.124-.136 1.893-1.86 5.018-1.788 6.968.167l.245.245c.857.86.857 2.26 0 3.118"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-cowboy-side_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatCowboySide;
